const $$splitComponentImporter = () => import('/src/src/routes/_anonymous/unsubscribe.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_anonymous/unsubscribe")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Unsubscribe",
      description: "Page title for the email unsubscribe page path"
    })
  }
});